import http from '@/features/shared/http/client';
import { SerializedContent, StoryGenerationOptions } from '@storyverse/shared';

export class StoryAIService {
    async generateStory(options: StoryGenerationOptions): Promise<SerializedContent[]> {
        try {
            const response = await http.post<{ result: SerializedContent[] }>('/generateStory', {
                type: 'story',
                data: options
            });
            return response.data.result;
        } catch (error) {
            console.error('Error generating story:', error);
            throw error;
        }
    }
}

export const storyAIService = new StoryAIService();
